export const GET_MISMATCH_ACTION = 'mismatch/GET_MISMATCH_ACTION'
export const GET_MISMATCH_ACTION_DONE = 'mismatch/GET_MISMATCH_ACTION_DONE'
export const GET_MISMATCH_ACTION_FAIL = 'mismatch/GET_MISMATCH_ACTION_FAIL'

export const GET_MISMATCH_XSL_ACTION = 'mismatch/GET_MISMATCH_XSL_ACTION'
export const GET_MISMATCH_XSL_ACTION_DONE = 'mismatch/GET_MISMATCH_XSL_ACTION_DONE'
export const GET_MISMATCH_XSL_ACTION_FAIL = 'mismatch/GET_MISMATCH_XSL_ACTION_FAIL'